if (!window.driftNavigationReady) {
  window.driftNavigationReady = true;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.dt-nav-group[open], .dt-mobile-navigation[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenus = [...document.querySelectorAll('.dt-nav-group[open], .dt-mobile-navigation[open]')];
    openMenus.forEach((menu) => { menu.open = false; });
    openMenus[0]?.querySelector('summary')?.focus();
  });
}
